import React, { useState, useEffect } from "react";
import Footer from "../../components/footer/Footer";
import Header1 from "../../components/header1/Header1";
import { FaEdit } from "react-icons/fa";
import { FaLinkedin, FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import { fetchStudentData } from "../../services/studentportalapis";
import { GoDotFill } from "react-icons/go";

const UserProfile = () => {
  const [profilePic, setProfilePic] = useState(null);
  const [userName, setUserName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [city, setCity] = useState("");
  const [homeTown, setHomeTown] = useState("");
  const [state, setState] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [collegeName, setCollegeName] = useState("");
  const [email, setEmail] = useState("");
  const [branchName, setBranchName] = useState("");
  const [collegeRollNo, setCollegeRollNo] = useState("");
  const [plannedPassOutBatch, setPlannedPassOutBatch] = useState("");
  const [university, setUniversity] = useState("");
  const [collegeCity, setCollegeCity] = useState("");
  const [collegeState, setCollegeState] = useState("");
  const [leetcodeStats, setLeetcodeStats] = useState(null);

  useEffect(() => {
    const getStudentData = async () => {
      try {
        let data = localStorage.getItem('student-details');
        data = JSON.parse(data);
        if (data === "" || data === null) {
            data = await fetchStudentData();
            localStorage.setItem('student-details', JSON.stringify(data));
        }

        // Update state with fetched data
        // setUserName(`${data.firstName} ${data.lastName}`);

        setUserName(`${capitalizeFirstLetter(data.firstName)} ${capitalizeFirstLetter(data.lastName)}`);
        setLinkedin(data.linkedinUrl);
        setMiddleName(data.middleName);
        setPhoneNumber(data.phone);
        setCollegeName(data.collegeName);
        setEmail(data.email);
        setBranchName(data.branchName);

        setCity(data.city);
        setHomeTown(data.homeTown);
        setState(data.state);
        if(data.coordinators){
          setCollegeRollNo(data.collegeRollNo);
        setPlannedPassOutBatch(data.plannedPassOutYear);
        setUniversity(data.university);
        setCollegeCity(data.collegeCity);
        setCollegeState(data.collegeState);
        }
        else{
          setCollegeRollNo(data.associateCollegeRollNo);
          setPlannedPassOutBatch(data.associatePlannedPassOutYear);
          setUniversity(data.associateUniversity);
          setCollegeCity(data.associateCollegeCity);
          setCollegeState(data.associateCollegeState);
        }
       
      } catch (error) {
        console.error("Error fetching student data:", error);
      }
    };

    const fetchLeetCodeStats = async () => {
      const studentDetails = localStorage.getItem("student-details");
      if (!studentDetails) {
        console.error("No student-details found in localStorage.");

        return;
      }

      const { leetcodeUserName } = JSON.parse(studentDetails); // Extract leetcodeUserName
      if (!leetcodeUserName) {
        console.error("leetcodeUserName not found in student-details.");

        return;
      }

      try {
        // Construct the API URL using the userName
        const url = `https://alfa-leetcode-api.onrender.com/${leetcodeUserName}/solved`;
        console.log("Fetching from API:", url);

        // Fetch data from the third-party API
        const response = await fetch(url);

        if (!response.ok) {
          console.error("API Error. Status:", response.status);

          return;
        }
        const data = await response.json();
        console.log("LeetCode data:", data); // Log the response data
        setLeetcodeStats({
          easySolved: data.easySolved,
          mediumSolved: data.mediumSolved,
          hardSolved: data.hardSolved,
        });
      } catch (error) {
        console.error("Error fetching LeetCode stats:", error);
      }
    };

    fetchLeetCodeStats();
    getStudentData();
  }, [localStorage.getItem("email")]);

  const handleImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (e) => setProfilePic(e.target.result);
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};


  return (
    <div className="flex flex-col min-h-screen md:ml-20 md:mr-20">
      <Header1 />
      <div className=" bg-gray-100">
        <div className="flex flex-col md:flex-row items-center my-6 space-y-6 md:space-y-0 md:space-x-6 px-4 md:px-10 md:ml-10 ">

          <div className="mt-4 text-center mx-4 md:mx-20">
            <h2 className="text-2xl font-semibold text-left">{userName}</h2>
            <p className="text-gray-500 flex items-center">
              <IoMail className="mr-2" />
              {email}
            </p>
            <p className="text-gray-500 flex items-center justify-center md:justify-start my-1">
              <FaPhoneAlt className="mr-2" />
              {phoneNumber}
            </p>
            <hr className="my-2 w-full" />
            <p className="text-blue-500 flex items-center justify-center md:justify-start">
              <FaLinkedin className="mr-2" />
              <a
                href={linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="underline"
              >
                {linkedin}
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white p-6">
        <h3 className="flex items-center text-lg font-semibold mb-4">
          {/* <span className="h-1 w-1 rounded-full bg-blue-500 mr-2"></span> */}
          <GoDotFill className=" text-blue-500 mr-2 place-items-end"/>

          Personal Information
        </h3>

        <div className="grid grid-cols-1 gap-3 px-5 md:px-20">
          <div className="info-item flex justify-between md:justify-start md:space-x-4">
            <label className="text-gray-500 w-1/3 text-left">First Name</label>
            <span className="text-left">{userName?.split(" ")[0]}</span>
          </div>
          <div className="info-item flex justify-between md:justify-start md:space-x-4">
            <label className="text-gray-500 w-1/3 text-left">Middle Name</label>
            <span className="text-left">{middleName || "N/A"}</span>
          </div>
          <div className="info-item flex justify-between md:justify-start md:space-x-4">
            <label className="text-gray-500 w-1/3 text-left">Last Name</label>
            <span className="text-left">{userName?.split(" ")[1] || "N/A"}</span>
          </div>

          <div className="info-item flex justify-between md:justify-start md:space-x-4">
            <label className="text-gray-500 w-1/3 text-left">City</label>
            <span className="text-left">{city || "N/A"}</span>
          </div>
          <div className="info-item flex justify-between md:justify-start md:space-x-4">
            <label className="text-gray-500 w-1/3 text-left">Place of Residence</label>
            <span className="text-left">{homeTown || "N/A"}</span>
          </div>
          <div className="info-item flex justify-between md:justify-start md:space-x-4">
            <label className="text-gray-500 w-1/3 text-left">State</label>
            <span className="text-left">{state || "N/A"}</span>
          </div>
        </div>
      </div>
      <hr className=" mx-10" />
      <div className="bg-white p-6">
        <h3 className="flex items-center text-lg font-semibold mb-4">
        <GoDotFill className=" text-blue-500 mr-2 place-items-baseline"/>
          Institute Details
        </h3>
        <div className="grid grid-cols-1 gap-3 px-5 md:px-20">
          <div className="info-item flex justify-between md:justify-start md:space-x-4">
            <label className="text-gray-500 w-1/3 text-left">
              Institute Name
            </label>
            <span className="text-left">{collegeName}</span>
          </div>
          <div className="info-item flex justify-between md:justify-start md:space-x-4">
            <label className="text-gray-500 w-1/3 text-left">
              Specialization
            </label>
            <span className="text-left">{branchName}</span>
          </div>

          <div className="info-item flex justify-between md:justify-start md:space-x-4">
            <label className="text-gray-500 w-1/3 text-left">
                Institute Unique Id
            </label>
            <span className="text-left">{collegeRollNo || "N/A"}</span>
          </div>
          <div className="info-item flex justify-between md:justify-start md:space-x-4">
            <label className="text-gray-500 w-1/3 text-left">
              Planned Graduation Completion Year
            </label>
            <span className="text-left">{plannedPassOutBatch || "N/A"}</span>
          </div>
          <div className="info-item flex justify-between md:justify-start md:space-x-4">
            <label className="text-gray-500 w-1/3 text-left">University</label>
            <span className="text-left">{university || "N/A"}</span>
          </div>
          <div className="info-item flex justify-between md:justify-start md:space-x-4">
            <label className="text-gray-500 w-1/3 text-left">
            Institute City
            </label>
            <span className="text-left">{collegeCity || "N/A"}</span>
          </div>
          <div className="info-item flex justify-between md:justify-start md:space-x-4">
            <label className="text-gray-500 w-1/3 text-left">
            Institute State
            </label>
            <span className="text-left">{collegeState || "N/A"}</span>
          </div>
        </div>
      </div>
      <hr className=" mx-10" />

      <Footer />
    </div>
  );
};

export default UserProfile;
